import React from "react";
import { graphql } from "gatsby";
import { Link } from "gatsby";
import { components } from "../slices";
import { SliceZone } from "@prismicio/react";
import { PrismicRichText } from "@prismicio/react";
import CustomRichText from '../components/CustomRichText';


export default function Article({ data, pageContext: { next, previous } }) {
  const content = data.prismicBlogPost.dataRaw["blog_content"];
  const blogImage = data.prismicBlogPost.dataRaw["blog_image"].url;
  const imageAlt = data.prismicBlogPost.dataRaw["blog_image"].alt || null;
  const blogTitle = data.prismicBlogPost.dataRaw["blog_title"][0].text;
  const doc = data.prismicBlogPost.data;

  return (
    <>
      <>
        <div className="px-8 mx-auto max-w-5xl">
          <div className="max-w-6xl mx-auto">
            <img src={blogImage} alt={imageAlt} className="rounded-md mt-12 " />
          </div>
          <h1 className="text-4xl md:text-center md:max-w-4xl md:mx-auto my-4 md:mb-16 md:mt-32 md:text-6xl">
            {blogTitle}
          </h1>
          <div className="max-w-2xl mx-auto blogArticle">
            <CustomRichText content={content} />
          </div>
          <SliceZone slices={doc.body} components={components} />

          <div className="mt-12 md:mt-16 grid grid-cols-2">
            <div className="max-w-xs col-start-1 col-end-2 justify-self-start">
              {previous && (
                <>
                  <div className="text-sm">Previous Article</div>
                  <Link
                    to={`/blog/${previous.uid}`}
                    className="hover:text-blue transition-colors font-semibold leading-5 block mt-1"
                  >
                    {previous.dataRaw["blog_title"][0].text}
                  </Link>
                </>
              )}
            </div>
            <div className="max-w-xs col-start-2 col-end-3 justify-self-end">
              {next && (
                <>
                  <div className="text-sm">Next Article</div>
                  <Link
                    to={`/blog/${next.uid}`}
                    className="hover:text-blue transition-colors font-semibold leading-5 block mt-1"
                  >
                    {next.dataRaw["blog_title"][0].text}
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </>
    </>
  );
}
export function Head({ data }) {
  const blogTitle = data.prismicBlogPost.dataRaw["blog_title"][0].text;
  const thumbnailImage =
    data.prismicBlogPost.dataRaw["thumbnail_image"].url || null;
  const descriptionPost =
    data.prismicBlogPost.dataRaw["article_description"][0].text || null;
  return (
    <>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <html lang="en" />
      <title>{`${blogTitle} | Bankjoy`}</title>
      <meta name="description" content={descriptionPost} />
      <meta name="image" property="og:image" content={thumbnailImage} />
      <link rel="preload" href="/fonts/fonts.css" as="style"></link>
      <link
        rel="canonical"
        href={`https://bankjoy.com/blog/${data.prismicBlogPost.uid}`}
      />
    </>
  );
}
export const query = graphql`
  query ($id: String) {
    prismicBlogPost(id: { eq: $id }) {
      dataRaw
      data {
        body {
          ... on PrismicBlogPostDataBodyNewsletter {
            slice_type
            primary {
              body_text {
                text
              }
              cta_button {
                text
              }
              headline {
                text
              }
            }
          }
        }
      }
      uid
    }
  }
`;
